var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    { staticClass: "page" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("dataScreening", {
            attrs: {
              propsData: {
                isCountry: false,
                adChannel: false,
                adPlacement: false,
                isDate: false
              }
            },
            on: { searchChange: _vm.searchChange }
          }),
          _vm.rawData.game_mark.indexOf("yjfm") == -1
            ? [
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "flex-1",
                        attrs: {
                          filterable: "",
                          placeholder: _vm.$t("pleaseChoose")
                        },
                        on: { change: _vm.getServer },
                        model: {
                          value: _vm.paramsData.is_prod,
                          callback: function($$v) {
                            _vm.$set(_vm.paramsData, "is_prod", $$v)
                          },
                          expression: "paramsData.is_prod"
                        }
                      },
                      _vm._l(_vm.severlist, function(item) {
                        return _c("el-option", {
                          key: item.label,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "flex-1",
                        attrs: {
                          multiple: "",
                          "collapse-tags": "",
                          clearable: "",
                          filterable: "",
                          placeholder: _vm.$t("pleaseSelectServer")
                        },
                        on: { change: _vm.YjfmSeverChange },
                        model: {
                          value: _vm.paramsData.server_id,
                          callback: function($$v) {
                            _vm.$set(_vm.paramsData, "server_id", $$v)
                          },
                          expression: "paramsData.server_id"
                        }
                      },
                      [
                        _c(
                          "el-checkbox",
                          {
                            on: { change: _vm.selectYjfmAll },
                            model: {
                              value: _vm.checked,
                              callback: function($$v) {
                                _vm.checked = $$v
                              },
                              expression: "checked"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("selectAll")))]
                        ),
                        _vm._l(_vm.serverList, function(item) {
                          return _c("el-option", {
                            key: item.serverID,
                            attrs: {
                              label: item.serverName,
                              value: item.serverID
                            }
                          })
                        })
                      ],
                      2
                    )
                  ],
                  1
                )
              ]
            : [
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "flex-1",
                        attrs: {
                          filterable: "",
                          placeholder: _vm.$t("pleaseChoose")
                        },
                        on: { change: _vm.envIdChange },
                        model: {
                          value: _vm.paramsData.env_id,
                          callback: function($$v) {
                            _vm.$set(_vm.paramsData, "env_id", $$v)
                          },
                          expression: "paramsData.env_id"
                        }
                      },
                      _vm._l(_vm.szgmEnv, function(item) {
                        return _c("el-option", {
                          key: item.label,
                          attrs: { label: item.label, value: item.id }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          filterable: "",
                          placeholder: _vm.$t("serverChannel")
                        },
                        on: { change: _vm.serverChange },
                        model: {
                          value: _vm.server_channel,
                          callback: function($$v) {
                            _vm.server_channel = $$v
                          },
                          expression: "server_channel"
                        }
                      },
                      _vm._l(_vm.serverChannel, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          clearable: "",
                          filterable: "",
                          placeholder: _vm.$t("showTestServer")
                        },
                        on: { change: _vm.serverChannelChange },
                        model: {
                          value: _vm.show_test,
                          callback: function($$v) {
                            _vm.show_test = $$v
                          },
                          expression: "show_test"
                        }
                      },
                      _vm._l(_vm.serverType, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          multiple: "",
                          "collapse-tags": "",
                          filterable: "",
                          clearable: "",
                          placeholder: _vm.$t("server")
                        },
                        on: { change: _vm.severChange },
                        model: {
                          value: _vm.paramsData.server_id,
                          callback: function($$v) {
                            _vm.$set(_vm.paramsData, "server_id", $$v)
                          },
                          expression: "paramsData.server_id"
                        }
                      },
                      [
                        _c(
                          "el-checkbox",
                          {
                            on: { change: _vm.selectAll },
                            model: {
                              value: _vm.checked,
                              callback: function($$v) {
                                _vm.checked = $$v
                              },
                              expression: "checked"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("selectAll")))]
                        ),
                        _vm._l(_vm.serverListYJ, function(item) {
                          return _c("el-option", {
                            key: item.serverID,
                            attrs: {
                              label: item.serverName,
                              value: item.serverID
                            }
                          })
                        })
                      ],
                      2
                    )
                  ],
                  1
                )
              ],
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  staticClass: "flex-1",
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("timeType")
                  },
                  on: { change: _vm.handleTimeTypeChange },
                  model: {
                    value: _vm.searchData.period_type,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "period_type", $$v)
                    },
                    expression: "searchData.period_type"
                  }
                },
                _vm._l(_vm.timeList, function(item) {
                  return _c("el-option", {
                    key: item.label,
                    attrs: { label: item.label, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm.searchData.period_type === "day"
            ? [
                _c(
                  "el-col",
                  { attrs: { span: 6 } },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        "picker-options": _vm.pickerOptionsDisableFuture,
                        type: "date",
                        "value-format": "yyyy-MM-dd",
                        placeholder: _vm.$t("selectBaseDay")
                      },
                      model: {
                        value: _vm.searchData.base_day,
                        callback: function($$v) {
                          _vm.$set(_vm.searchData, "base_day", $$v)
                        },
                        expression: "searchData.base_day"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 6 } },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        "picker-options": _vm.pickerOptionsCompareDay,
                        type: "dates",
                        "value-format": "yyyy-MM-dd",
                        placeholder: _vm.$t("selectCompareDays")
                      },
                      model: {
                        value: _vm.searchData.compare_days,
                        callback: function($$v) {
                          _vm.$set(_vm.searchData, "compare_days", $$v)
                        },
                        expression: "searchData.compare_days"
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm.searchData.period_type === "week"
            ? [
                _c(
                  "div",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 3 } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            "picker-options": _vm.pickerOptionsDisableFuture,
                            type: "month",
                            "value-format": "yyyy-MM",
                            placeholder: _vm.$t("baseYearMonth")
                          },
                          model: {
                            value: _vm.searchData.base_year_month,
                            callback: function($$v) {
                              _vm.$set(_vm.searchData, "base_year_month", $$v)
                            },
                            expression: "searchData.base_year_month"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 3 } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              clearable: "",
                              placeholder: _vm.$t("baseWeek")
                            },
                            model: {
                              value: _vm.searchData.base_week,
                              callback: function($$v) {
                                _vm.$set(_vm.searchData, "base_week", $$v)
                              },
                              expression: "searchData.base_week"
                            }
                          },
                          _vm._l([1, 2, 3, 4, 5], function(w) {
                            return _c("el-option", {
                              key: w,
                              attrs: {
                                disabled: _vm.isFutureWeek(
                                  _vm.searchData.base_year_month,
                                  w
                                ),
                                label: _vm.$t("weekLabel", { week: w }),
                                value: w
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 3 } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              size: "small",
                              icon: "el-icon-plus"
                            },
                            on: { click: _vm.addCompareItem }
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("addCompareGroup")) + " "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "flex-wrap": "wrap",
                      gap: "10px",
                      "align-items": "center",
                      width: "100%"
                    }
                  },
                  [
                    _c("el-col", { attrs: { span: 24 } }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-wrap": "wrap",
                            gap: "10px",
                            "align-items": "center"
                          }
                        },
                        _vm._l(_vm.searchData.compare_items, function(
                          item,
                          index
                        ) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticStyle: {
                                display: "flex",
                                gap: "10px",
                                "align-items": "center",
                                "margin-bottom": "8px"
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "150px" },
                                attrs: {
                                  "picker-options":
                                    _vm.pickerOptionsDisableFuture,
                                  type: "month",
                                  "value-format": "yyyy-MM",
                                  placeholder: _vm.$t("selectYearMonth")
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.validateWeekItem(item, index)
                                  }
                                },
                                model: {
                                  value: item.year_month,
                                  callback: function($$v) {
                                    _vm.$set(item, "year_month", $$v)
                                  },
                                  expression: "item.year_month"
                                }
                              }),
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "120px" },
                                  attrs: {
                                    clearable: "",
                                    placeholder: _vm.$t("selectWeek"),
                                    disabled: !item.year_month
                                  },
                                  model: {
                                    value: item.week,
                                    callback: function($$v) {
                                      _vm.$set(item, "week", $$v)
                                    },
                                    expression: "item.week"
                                  }
                                },
                                _vm._l([1, 2, 3, 4, 5], function(w) {
                                  return _c("el-option", {
                                    key: w,
                                    attrs: {
                                      disabled: _vm.isWeekOptionDisabled(
                                        item.year_month,
                                        w,
                                        index
                                      ),
                                      label: _vm.$t("weekLabel", { week: w }),
                                      value: w
                                    }
                                  })
                                }),
                                1
                              ),
                              _c("el-button", {
                                attrs: {
                                  type: "danger",
                                  size: "small",
                                  icon: "el-icon-minus",
                                  circle: "",
                                  disabled:
                                    _vm.searchData.compare_items.length <= 1
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.removeCompareItem(index)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        }),
                        0
                      )
                    ])
                  ],
                  1
                )
              ]
            : _vm.searchData.period_type === "month"
            ? [
                _c(
                  "el-col",
                  { attrs: { span: 6 } },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        "picker-options": _vm.pickerOptionsDisableFuture,
                        type: "month",
                        "value-format": "yyyy-MM",
                        placeholder: _vm.$t("selectBaseMonth")
                      },
                      model: {
                        value: _vm.searchData.base_month,
                        callback: function($$v) {
                          _vm.$set(_vm.searchData, "base_month", $$v)
                        },
                        expression: "searchData.base_month"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 6 } },
                  [
                    _c("el-date-picker", {
                      attrs: {
                        "picker-options": _vm.pickerOptionsCompareMonth,
                        type: "month",
                        "value-format": "yyyy-MM",
                        placeholder: _vm.$t("selectMonthToAdd")
                      },
                      on: { change: _vm.handleMonthChange },
                      model: {
                        value: _vm.currentMonth,
                        callback: function($$v) {
                          _vm.currentMonth = $$v
                        },
                        expression: "currentMonth"
                      }
                    }),
                    _vm._l(_vm.searchData.compare_months, function(
                      month,
                      index
                    ) {
                      return _c(
                        "el-tag",
                        {
                          key: month,
                          staticStyle: {
                            "margin-right": "5px",
                            "margin-bottom": "5px"
                          },
                          attrs: { closable: "" },
                          on: {
                            close: function($event) {
                              return _vm.removeMonth(index)
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(month) + " ")]
                      )
                    })
                  ],
                  2
                )
              ]
            : _vm._e()
        ],
        2
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: !_vm.tableData.length },
                  on: { click: _vm.exportdata }
                },
                [_vm._v(_vm._s(_vm.$t("export")))]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: { click: _vm.searchClick }
                },
                [_vm._v(_vm._s(_vm.$t("search")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.tableData.length
        ? _c(
            "el-table",
            {
              directives: [
                {
                  name: "sticky-table-header",
                  rawName: "v-sticky-table-header",
                  value: 0,
                  expression: "0"
                }
              ],
              ref: "tableRef",
              attrs: { id: "tableRef", data: _vm.tableData, border: "" }
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("date"),
                  prop: "date",
                  fixed: "",
                  "min-width": "120",
                  align: "center"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("span", [_vm._v(_vm._s(scope.row.date))]),
                          scope.row.is_base
                            ? _c(
                                "el-tag",
                                {
                                  staticStyle: { "margin-left": "5px" },
                                  attrs: { size: "mini", type: "success" }
                                },
                                [_vm._v(_vm._s(_vm.$t("baseLabel")))]
                              )
                            : _vm._e()
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  1625538752
                )
              }),
              _vm._l(_vm.metricColumns, function(col) {
                return _c("el-table-column", {
                  key: col.prop,
                  attrs: {
                    label: col.label,
                    prop: col.prop,
                    "min-width": "150",
                    align: "center"
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "div",
                              { staticClass: "metric-cell" },
                              [
                                _c("span", { staticClass: "value-current" }, [
                                  _vm._v(_vm._s(scope.row[col.prop].value))
                                ]),
                                !scope.row.is_base
                                  ? [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "value-diff",
                                          class: {
                                            "is-up":
                                              scope.row[col.prop].diff > 0,
                                            "is-down":
                                              scope.row[col.prop].diff < 0
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " (" +
                                              _vm._s(
                                                scope.row[col.prop].diff > 0
                                                  ? "+"
                                                  : ""
                                              ) +
                                              _vm._s(scope.row[col.prop].diff) +
                                              ") "
                                          )
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "value-diff",
                                          class: {
                                            "is-up":
                                              scope.row[col.prop].growthRate >
                                              0,
                                            "is-down":
                                              scope.row[col.prop].growthRate < 0
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " (" +
                                              _vm._s(
                                                scope.row[col.prop].growthRate >
                                                  0
                                                  ? "+"
                                                  : ""
                                              ) +
                                              _vm._s(
                                                scope.row[col.prop].growthRate +
                                                  "%"
                                              ) +
                                              ") "
                                          )
                                        ]
                                      )
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                })
              })
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }